<template>
  <div class="admin-page">
    <h2>Журнал модерации</h2>

    <div class="admin-filters">
      <label class="admin-filter">
        <span>Действие</span>
        <select v-model="kindFilter" class="admin-select" @change="loadActions">
          <option value="">Все</option>
          <option v-for="kind in MODERATION_ACTION_KINDS" :key="kind" :value="kind">
            {{ moderationActionLabel(kind) }}
          </option>
        </select>
      </label>
      <label class="admin-filter">
        <span>Тип цели</span>
        <select v-model="targetTypeFilter" class="admin-select" @change="loadActions">
          <option value="">Все</option>
          <option v-for="type in MODERATION_TARGET_TYPES" :key="type" :value="type">
            {{ targetTypeLabel(type) }}
          </option>
        </select>
      </label>
    </div>

    <p v-if="error" class="error-message">{{ error }}</p>

    <div class="panel">
      <p v-if="loading" class="empty-text">Загрузка...</p>
      <p v-else-if="actions.length === 0" class="empty-text">Записей нет.</p>

      <div v-else class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>Дата</th>
              <th>Актор</th>
              <th>Действие</th>
              <th>Цель</th>
              <th>Детали</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="action in actions" :key="action.id">
              <td data-label="Дата">{{ formatDateTime(action.created_at) }}</td>
              <td data-label="Актор">
                <UserIdentity v-if="action.actor" :user="action.actor" size="sm" />
                <span v-else>—</span>
              </td>
              <td data-label="Действие">{{ moderationActionLabel(action.action) }}</td>
              <td data-label="Цель">{{ targetTypeLabel(action.target_type) }} #{{ action.target_id }}</td>
              <td data-label="Детали" class="admin-metadata">{{ formatModerationMetadata(action.metadata) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import UserIdentity from '../../components/UserIdentity.vue'
import { fetchModerationActions } from '../../api/admin'
import { extractApiError } from '../../utils/apiError'
import { formatDateTime } from '../../utils/formatDateTime'
import { formatModerationMetadata } from '../../utils/formatModerationMetadata'
import {
  MODERATION_ACTION_KINDS,
  MODERATION_TARGET_TYPES,
  moderationActionLabel,
  targetTypeLabel,
} from '../../utils/moderationLabels'

const actions = ref([])
const loading = ref(true)
const error = ref('')
const kindFilter = ref('')
const targetTypeFilter = ref('')

async function loadActions() {
  loading.value = true
  error.value = ''
  try {
    actions.value = await fetchModerationActions({
      kind: kindFilter.value || undefined,
      target_type: targetTypeFilter.value || undefined,
    })
  } catch (err) {
    error.value = extractApiError(err, 'Не удалось загрузить журнал')
  } finally {
    loading.value = false
  }
}

onMounted(loadActions)
</script>
